import React from 'react';

import Pricing from '@components/Pricing/Pricing';

import styles from './InfoBox.module.scss';
import { OfferItemPricing } from 'types/offer.types';

interface InfoBoxProps {
  from?: string;
  monthUnit?: string;
  pricingRanges: {
    key: string;
    condition: string;
    pricing: OfferItemPricing;
  }[];
}

export const InfoBox = ({ from = '', monthUnit = 'm', pricingRanges }: InfoBoxProps) => {
  return (
    <div className={styles.container}>
      {pricingRanges.map(({ key, condition, pricing }) => {
        return (
          pricing && (
            <div className={styles.content} key={key}>
              <div className={styles.text}>{condition}</div>
              <Pricing
                price={pricing.recurringAmount}
                referencePrice={pricing.referenceRecurringAmount}
                isReferencePriceActive={pricing.isReferenceAmountActive}
                from={from}
                postfix={monthUnit}
                className={styles.text}
              />
            </div>
          )
        );
      })}
    </div>
  );
};
